import {OrderStatus} from '../enums/order-status';
import {Order} from '../models/order';

export const isOrderStatusActive = (orderStatus: OrderStatus): boolean =>
    orderStatus === OrderStatus.ACTIVE
    || orderStatus === OrderStatus.PARTIALLY_FILLED
    || orderStatus === OrderStatus.WAITING_ACTIVATION;

export const isOrderActive = (order: Order): boolean =>
    isOrderStatusActive(order.state.orderStatus);
